// path: src/components/DifficultyDialog.js
import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import {
    CHALLENGING_START_LEVEL,
    INSANE_START_LEVEL,
    isChallengingUnlocked,
    isInsaneUnlocked,
} from "../utils/progression";

export default function DifficultyDialog({ open, onClose, onPick }) {
    const challengingLocked = !isChallengingUnlocked();
    const insaneLocked = !isInsaneUnlocked();

    return (
    <Dialog open={open} onClose={onClose} aria-labelledby="difficulty-title">
        <DialogTitle id="difficulty-title">Choose difficulty</DialogTitle>

        <DialogContent dividers>
        <Typography gutterBottom>
            <strong>Easy</strong> starts at Level 1.
        </Typography>
        <Typography gutterBottom>
            <strong>Challenging</strong> starts at Level {CHALLENGING_START_LEVEL} (last 3×3 level).
        </Typography>
        <Typography gutterBottom>
            <strong>Insane</strong> starts at Level {INSANE_START_LEVEL} (last 4×4 level).
        </Typography>

        {(challengingLocked || insaneLocked) && (
            <Typography style={{ marginTop: 12 }}>
            Locked modes unlock once you reach those levels in a normal run.
            </Typography>
        )}
        </DialogContent>

        <DialogActions>
        <Button onClick={() => onPick("easy")} variant="contained" color="primary">
            Easy
        </Button>

        <Button
            onClick={() => onPick("challenging")}
            variant="contained"
            disabled={challengingLocked}
            title={challengingLocked ? "Reach the last 3×3 level to unlock" : ""}
        >
            Challenging
        </Button>

        <Button
            onClick={() => onPick("insane")}
            variant="contained"
            disabled={insaneLocked}
            title={insaneLocked ? "Reach the last 4×4 level to unlock" : ""}
        >
            Insane
        </Button>

        <Button onClick={onClose}>Cancel</Button>
        </DialogActions>
    </Dialog>
    );
}
